import { MarketingSuppressionReason } from "@redotech/redo-model/marketing/marketing-suppression/marketing-suppression-zod-schema";
import * as z from "zod/v4";

export const getCustomerSuppressionInfo = {
  name: "getCustomerSuppressionInfo" as const,
  input: z.object({ customerId: z.string() }),
  output: z.object({
    emailSuppressionReasons: z.array(z.enum(MarketingSuppressionReason)),
    smsSuppressionReasons: z.array(z.enum(MarketingSuppressionReason)),
  }),
};
